import WidgetLocation from 'components/Widgets/WidgetLocation';

const LocationTypeField = ({ item, selectItem, setNewSelectItem, disabled }) => {
  return (
    <WidgetLocation
      item={item}
      value={selectItem}
      onChange={setNewSelectItem}
      disabled={disabled}
    />
  );
};

export default LocationTypeField;
